module.exports = __webpack_public_path__ + "img/WATER-FOOTPRINT.a56ab809.png";